import { connect } from 'react-redux';
import ZoneProductApplicationInputKeypadContainer from './ZoneProductApplicationInputKeypadContainer';

export default connect(
  () => {
    return {};
  },
  (dispatch, ownProps) => {
    const { accessInputValue, onChange, onClose } = ownProps;
  
    return {
      onTapButton: (e, buttonType) => {
        e.stopPropagation();
        switch (buttonType) {
          case 'cancel':
            onClose({ revert: true });
            break;
          case 'done':
            onClose({ revert: false });
            break;
          case 'erase':
            onChange(`${accessInputValue()}`.slice(0, -1));
            break;
          default:
            onChange(`${accessInputValue()}${buttonType}`);
        }
      }
    };
  }
)(ZoneProductApplicationInputKeypadContainer);